module.exports = __webpack_public_path__ + "img/sq.d811cc92.png";